import { render, staticRenderFns } from "./AgendaModalInfo.vue?vue&type=template&id=5330f5ec"
import script from "./AgendaModalInfo.vue?vue&type=script&lang=js"
export * from "./AgendaModalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports